import { render, staticRenderFns } from "./creatComment.vue?vue&type=template&id=cbaafdb6&scoped=true"
import script from "./creatComment.vue?vue&type=script&lang=js"
export * from "./creatComment.vue?vue&type=script&lang=js"
import style0 from "./creatComment.vue?vue&type=style&index=0&id=cbaafdb6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaafdb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbaafdb6')) {
      api.createRecord('cbaafdb6', component.options)
    } else {
      api.reload('cbaafdb6', component.options)
    }
    module.hot.accept("./creatComment.vue?vue&type=template&id=cbaafdb6&scoped=true", function () {
      api.rerender('cbaafdb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/comment/creatComment.vue"
export default component.exports